import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { Element } from 'interfaces';

import { breakpoints } from 'styles/basic';

interface Title {
  element?: Element;
  size?: 'big' | 'normal' | 'small';
  color?: 'black' | 'white' | 'primary' | 'secondary' | 'trinary';
  noMargin?:  boolean | undefined;
}

const Wrapper = styled.span<Title>`
  line-height: 1.2;

  ${(props) => props.color === 'primary' && css`
    color: ${props.theme.mainColors.primary};
  `};
  ${(props) => props.color === 'secondary' && css`
    color: ${props.theme.mainColors.secondary};
  `};
  ${(props) => props.color === 'white' && css`
    color: ${props.theme.colorMono.white};
  `};
  ${(props) => props.color === 'trinary' && css`
    color: ${props.theme.mainColors.trinary};
  `};

  ${(props) => props.size === 'big' && css`
    font-size: 2.1rem;

    @media (min-width: ${breakpoints.smallTablet}) {
      font-size: 2.8rem;
    }
  `};
  ${(props) => props.size === 'normal' && css`
    font-size: 1.6rem;

    @media (min-width: ${breakpoints.smallTablet}) {
      font-size: 2rem;
    }
  `};
  ${(props) => props.size === 'small' && css`
    font-size: 1.4rem;

    @media (min-width: ${breakpoints.smallTablet}) {
      font-size: 1.6rem;
    }
  `};

  ${(props) => props.noMargin && css`
    margin-bottom: 0;
  `};

  svg {
    ${(props) => props.size === 'big' && css`
      width: 2.5rem;
      height: 2.5rem;
    `};
    ${(props) => props.size === 'normal' && css`
      width: 2rem;
      height: 2rem;
    `};
    ${(props) => props.size === 'small' && css`
      width: 1.5rem;
      height: 1.5rem;
    `};
  }
`;

export { Wrapper };
